import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { Fonts, HyperLink, LinkStyles, LinkTypes, YukaColorPalette } from "yuka";

import space from "../images/space.png";
import { ROUTING_PATH } from "../routes/constants";
import SiteLogo from "../utils/svgs/SiteLogo";
import applyOpacityToHex from "../utils/applyOpacityToHex";

const StyledByline = styled.div`
  margin-bottom: 48px;
`;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* fill the 100vh app shell (StyledHDContainer clips overflow) and scroll
     internally, so tall content (e.g. the onboarding form) scrolls on small
     screens rather than clipping the header */
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  background-image: linear-gradient(
      180deg,
      transparent,
      ${applyOpacityToHex(YukaColorPalette.surface0, 0.5)} 100%
    ),
    url(${space});
  background-size: cover;
  background-position: center;
`;

const StyledMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;

  > * {
    max-width: 600px;
  }
`;

const StyledFooter = styled.div`
  width: 100%;
  max-width: 600px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 32px;
  padding: 24px 0 26px;

  > :last-child {
    display: flex;
    gap: 32px;
    align-items: center;
  }
`;

const LoginBase = ({ children, bylineText }) => (
  <StyledWrapper>
    <StyledMain>
      <SiteLogo size={28} />
      <StyledByline>
        <Fonts.Headline1theme50>{bylineText}</Fonts.Headline1theme50>
      </StyledByline>
      <div>{children}</div>
    </StyledMain>
    <StyledFooter>
      <Fonts.Body1theme50>&copy; Zanbato, Inc. {new Date().getFullYear()}</Fonts.Body1theme50>
      <Fonts.Body1theme50>
        <HyperLink
          linkStyle={LinkStyles.SUPPORT}
          linkType={LinkTypes.EXTERNAL_LINK}
          url={ROUTING_PATH.AGREEMENT("tou")}
        >
          <Fonts.Body1theme50>Terms of Use</Fonts.Body1theme50>
        </HyperLink>
        <HyperLink
          linkStyle={LinkStyles.SUPPORT}
          linkType={LinkTypes.EXTERNAL_LINK}
          url={ROUTING_PATH.AGREEMENT("privacy")}
        >
          <Fonts.Body1theme50>Privacy Policy</Fonts.Body1theme50>
        </HyperLink>
      </Fonts.Body1theme50>
    </StyledFooter>
  </StyledWrapper>
);

LoginBase.propTypes = {
  bylineText: PropTypes.string,
  children: PropTypes.node,
};

LoginBase.defaultProps = {
  bylineText: "",
  children: null,
};

export default LoginBase;
